module.exports = __webpack_public_path__ + "img/ic_discount-code.56f1d7a.svg";